export default __webpack_public_path__ + "static/media/artwork-2.27470d08.png";